
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"57","height":"57","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.5 0C12.768 0 0 12.768 0 28.5S12.768 57 28.5 57 57 44.232 57 28.5 44.232 0 28.5 0zm-5.7 42.75L8.55 28.5l4.018-4.018L22.8 34.684l21.631-21.632L48.45 17.1 22.8 42.75z","fill":"#108999"}})])
          )
        }
      }
    